const PARAGRAPH_ODDS_CALCULATOR = (uuid: string, language: string) => `
  blockDataUUID(uuid: "${uuid}", language: "${language}") {
    type
    uuid
    id
    title
    ... on OddsCalculator {
      id
      heading
      americanLabel
      americanPlaceholder
      basedOnLabel
      clearButtonLabel
      decimalLabel
      definition
      decimalPlaceholder
      fractionalLabel
      fractionalPlaceholder
      hongKongLabel
      hongKongPlaceholder
      introduction
      linksHeading
      malayLabel
      malayPlaceholder
      oddsFormatOptions
      oddsIntroduction
      percentageLabel
      otherTools {
        toolIcon
        toolLink
        toolTitle
      }
      percentagePlaceholder
      possibleWinningsLabel
      title
      type
      uuid
    }
  }
`;

export default PARAGRAPH_ODDS_CALCULATOR;
